module.exports = __webpack_public_path__ + "static/media/archero2_page_area01_img_en@2x.2cb68d7b.jpg";